'use client';
import Script from 'next/script';
import { useAdsStore } from '@/features/ads/internal/state/ads-slice';

//https://developers.google.com/publisher-tag/guides/get-started
export const GooglePublisherTagLoader = () => {
  const setGptLoaded = useAdsStore((state) => state.setGptLoaded);
  const handleGptLoaded = () => {
    setGptLoaded(true);
  };
  const handleError = (e: Event | ErrorEvent) => {
    console.error('Failed to load gpt.js', e);
  };
  return (
    <Script
      type='application/javascript'
      strategy='afterInteractive'
      src='https://securepubads.g.doubleclick.net/tag/js/gpt.js'
      onLoad={handleGptLoaded}
      onError={handleError}
    />
  );
};
